import { render, staticRenderFns } from "./ResCommon.vue?vue&type=template&id=bfa89858&scoped=true"
import script from "./ResCommon.vue?vue&type=script&lang=js"
export * from "./ResCommon.vue?vue&type=script&lang=js"
import style0 from "./ResCommon.vue?vue&type=style&index=0&id=bfa89858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa89858",
  null
  
)

export default component.exports